<template>
  <div class="component-tablebox">
    <promo-template-a4 v-show="false" :data="templateDataA4" ref="promoTemplateA4"></promo-template-a4>
    <promo-template-a7 v-show="false" :data="templateDataA7" ref="promoTemplateA7"></promo-template-a7>
    <promo-template-a4-msr v-show="false" :data="templateDataA4MSR" ref="promoTemplateA4Msr"></promo-template-a4-msr>
    <promo-template-a7-msr v-show="false" :data="templateDataA7MSR" ref="promoTemplateA7Msr"></promo-template-a7-msr>
    <b-row
      :class="{
        ' mt-2 mb-3 mx-2': !isDarkMode,
        'mt-2 mb-3 bg-dark text-light mx-2': isDarkMode
      }"
    >
      <b-col class="m-1 box-shadow2 p-4 dashHead" style="border-radius: 20px">
        <b-overlay :show="reportLoading" :variant="!isDarkMode ? 'light' : 'dark'" rounded="sm" no-wrap>
          <template #overlay>
            <div class="d-flex justify-content-center align-items-center h-100">
              <b-spinner :variant="!isDarkMode ? 'dark' : 'light'" label="Loading"></b-spinner>
            </div>
          </template>
        </b-overlay>
        <b-col>
          <b-row>
            <b-col>
              <h3>POP Analytics </h3>
            </b-col>
            <b-col>
              <b-form-select
                aria-placeholder="select"
                v-model="mainSelectedFilter"
                :options="mainFilterOptions"
                :class="{
                  'box-shadow2 mb-2': !isDarkMode,
                  'box-shadow2 bg-dark text-light mb-2': isDarkMode
                }"
              ></b-form-select>
            </b-col>
            <b-col>
              <b-form-select
                v-model="secondarySelectedFilter"
                :options="secondaryFilterOptions"
                :class="{
                  'box-shadow2  mb-2': !isDarkMode,
                  'box-shadow2 bg-dark text-light  mb-2': isDarkMode
                }"
              ></b-form-select>
            </b-col>
          </b-row>
        </b-col>
        <h4> {{ updateTime ? `Updated at : ${updateTime}` : '' }}</h4>
        <div class="row">
          <div class="col-md-4 d-flex flex-column mt-2">
            <h6>{{ deactivatedPromo ? `Deactivated Promo : ${deactivatedPromo}` : '' }}</h6>
            <h6>{{ expiredPromo ? `Expired Promo : ${expiredPromo}` : '' }} </h6>
            <h6>{{ newPromoLength ? `New Promo : ${newPromoLength}` : '' }} </h6>
            <h6>{{ allPrintedCount ? `Total Printed : ${allPrintedCount}` : '' }}</h6>
            <h6>{{ stockAvailable ? `Total Available : ${stockAvailable}` : '' }}</h6>
          </div>
          <div class="col-md-4 d-flex flex-column mt-2">
            <h6>{{ noOfStores ? `Total Stores : ${noOfStores}` : '' }}</h6>
            <h6>{{ mysrPromo ? `Total MSR Promo : ${mysrPromo}` : '' }}</h6>
            <h6>{{ mysrPrintedPromo ? `Total MSR Printed : ${mysrPrintedPromo}` : '' }} </h6>
          </div>
          <div class="col-md-4 mt-2">
            <h6>
              {{
                noOfStores && deactivatedPromo
                  ? `Avg. Deactivated Promo : ${(deactivatedPromo / noOfStores).toFixed(1)}`
                  : ''
              }}
            </h6>
            <h6>
              {{ noOfStores && expiredPromo ? `Avg. Expired Promo : ${(expiredPromo / noOfStores).toFixed(1)}` : '' }}
            </h6>
            <h6>
              {{ noOfStores && newPromoLength ? `Avg. New Promo : ${(newPromoLength / noOfStores).toFixed(1)}` : '' }}
            </h6>
            <h6>
              {{ noOfStores && allPrintedCount ? `Avg. Printed : ${(allPrintedCount / noOfStores).toFixed(1)}` : '' }}
            </h6>
            <h6>
              {{ noOfStores && stockAvailable ? `Avg. Available : ${(stockAvailable / noOfStores).toFixed(1)}` : '' }}
            </h6>
          </div>
        </div>
      </b-col>
    </b-row>
    <b-row v-if="showToolbar" class="table-top-wrapper mb-2 mx-0">
      <b-col sm="12" lg="8" class="px-0">
        <b-form inline @submit.prevent>
          <b-input-group data-v-step="0" class="box-shadow2 ml-2 mb-2">
            <b-form-input
              :class="{
                'bg-light text-dark': !isDarkMode,
                'bg-dark text-light placeholder-light': isDarkMode
              }"
              v-model="searchTerm"
              @keydown.native="search"
              placeholder="Search..."
            ></b-form-input>
            <template #append v-if="searchItems">
              <b-dropdown
                :menu-class="isDarkMode ? 'bg-dark box-shadow2' : 'box-shadow2'"
                :text="selectedSearchVariable"
                :variant="isDarkMode ? 'primary' : 'success'"
              >
                <b-dropdown-item
                  :link-class="isDarkMode ? 'text-light bg-dark' : ''"
                  v-for="item in searchItems"
                  :key="item"
                  @click="selectedSearchVariable = item"
                  >{{ item }}</b-dropdown-item
                >
              </b-dropdown>
            </template>
          </b-input-group>
          <b-form-select
            data-v-step="1"
            v-model="filterSelected"
            :options="filterOptions"
            :class="{
              'box-shadow2 ml-2 mb-2  bg-light text-dark': !isDarkMode,
              'box-shadow2 ml-2 mb-2 bg-dark text-light': isDarkMode
            }"
          ></b-form-select>
          <b-form-select
            v-model="filterSelectedForType"
            :options="filterOptionsForType"
            :class="{
              'box-shadow2 ml-2 mb-2  bg-light text-dark': !isDarkMode,
              'box-shadow2 ml-2 mb-2 bg-dark text-light': isDarkMode
            }"
          ></b-form-select>
          <b-form-select
            data-v-step="1"
            v-model="filterSelectedForSoh"
            :options="filterOptionsForSoh"
            :class="{
              'box-shadow2 ml-2 mb-2  bg-light text-dark': !isDarkMode,
              'box-shadow2 ml-2 mb-2 bg-dark text-light': isDarkMode
            }"
          ></b-form-select>
          <b-input-group>
            <multiselect
              v-model="filterSelectedForFamily"
              :options="filterOptionsForFamily"
              class="box-shadow2 ml-2 mb-2"
              placeholder="Search Family Type"
              :class="{
                'box-shadow3': !isDarkMode,
                darkMode: isDarkMode
              }"
            ></multiselect>
          </b-input-group>
        </b-form>
      </b-col>

      <b-col sm="12" lg="4">
        <b-form data-v-step="2" inline class="float-right">
          <b-input-group class="box-shadow2 ml-2 mb-2">
            <b-input-group-append>
              <b-form-datepicker
                button-only
                id="start-datepicker"
                placeholder="Start Date"
                :min="minDate"
                :max="maxDate"
                :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                v-model="startDateValue"
              ></b-form-datepicker>
            </b-input-group-append>
            <b-form-input
              sm
              id="example-input"
              v-model="startDateValue"
              type="text"
              placeholder="Start Date"
              autocomplete="off"
              :class="{
                '': !isDarkMode,
                'bg-dark text-light placeholder-light': isDarkMode
              }"
              disabled
            ></b-form-input>
          </b-input-group>
          <b-button
            :class="{
              'box-shadow2 btn btn-success ml-2 mb-2': !isDarkMode,
              'btn btn-primary text-light ml-2 mb-2': isDarkMode
            }"
            @click="applyDate"
            >Apply</b-button
          >
          <b-button
            :variant="isDarkMode ? 'outline-light' : 'outline-secondary'"
            class="box-shadow2 ml-2 mb-2"
            @click="clearDate"
            >Clear</b-button
          >
        </b-form>
      </b-col>
    </b-row>

    <!-- download buttons -->
    <b-row class="table-bottom-wrapper mb-3 mx-0 p-2 columnsReverse">
      <b-col sm="12" lg="8" class="px-0 d-flex align-items-center">
        <b-row>
          <b-col sm="12" lg="12">
            <input
              :checked="allSelected"
              :disabled="isDisabled"
              @click="selectAll"
              class="allimage"
              type="checkbox"
              id="scales"
            />
            <label for="scales" class="px-2">Select all </label>
            <label class="ml-3">
              <input type="checkbox" v-model="showOnlyMyrd" />
              Show only MSR POP
            </label>
            <b-button
              data-v-step="3"
              :disabled="this.selectedArticles.length < 1"
              v-if="showPrint"
              size="sm"
              :class="{
                'box-shadow2 btn btn-success ml-2 mb-2 mr-2': !isDarkMode,
                'btn btn-primary text-light ml-2 mb-2 mr-2': isDarkMode
              }"
              @click="printAll('A4')"
            >
              <font-awesome-icon :icon="['fas', 'clone']" class="mr-1" />{{ printTextA4 }}
            </b-button>
            <b-button
              data-v-step="3"
              :disabled="this.selectedArticles.length < 1"
              v-if="showPrint"
              v-b-modal.modal-lg
              size="sm"
              :class="{
                'box-shadow2 btn btn-success mb-2 mr-2': !isDarkMode,
                'btn btn-primary text-light mb-2 mr-2': isDarkMode
              }"
              @click="printAll('A7')"
            >
              <font-awesome-icon :icon="['fas', 'copy']" class="mr-1" />{{ printTextA7 }}
            </b-button>
            <b-modal
              :header-bg-variant="isDarkMode ? 'dark' : 'light'"
              :header-text-variant="isDarkMode ? 'light' : 'dark'"
              :body-bg-variant="isDarkMode ? 'dark' : 'light'"
              :footer-bg-variant="isDarkMode ? 'dark' : 'light'"
              :body-text-variant="isDarkMode ? 'light' : 'dark'"
              id="modal-lg"
              size="lg"
              v-model="modalVisible"
              title="Enter number of copy per item"
            >
              <div v-for="(array, i) in inputSets" :key="i">
                <b-row class="my-2">
                  <b-col lg="9" sm="12">
                    <input
                      type="text"
                      :class="{
                        'form-control bg-light text-dark': !isDarkMode,
                        'form-control bg-dark text-light placeholder-light': isDarkMode
                      }"
                      disabled
                      :value="array.articleDescription"
                      :placeholder="array.articleDescription"
                  /></b-col>
                  <b-col lg="2" sm="12">
                    <input
                      type="number"
                      min="1"
                      max="3"
                      onkeyup="if (this.value > 3) this.value = 1;"
                      :class="{
                        'form-control inputValues bg-light text-dark': !isDarkMode,
                        'form-control inputValues bg-dark text-light placeholder-light': isDarkMode
                      }"
                      placeholder="1"
                  /></b-col>
                  <b-col lg="1" sm="12">
                    <button
                      @click="removeArticle(i)"
                      :class="{ 'btn btn-danger': !isDarkMode, 'btn btn-outline-danger': isDarkMode }"
                      >X</button
                    ></b-col
                  >
                </b-row>
              </div>
              <template #modal-footer>
                <button
                  @click="clickModalPrint()"
                  :class="{
                    'box-shadow2 btn btn-success': !isDarkMode,
                    'btn btn-primary text-light': isDarkMode
                  }"
                  >Print</button
                >
                <button
                  @click="modalVisible = false"
                  :class="{
                    'box-shadow2 btn btn-danger': !isDarkMode,
                    'btn btn-outline-danger text-light': isDarkMode
                  }"
                  >Cancel</button
                >
              </template>
            </b-modal>

            <b-button
              data-v-step="3"
              v-if="showPrint"
              size="sm"
              :class="{
                'box-shadow2 btn btn-success mb-2 mr-2': !isDarkMode,
                'btn btn-primary text-light mb-2 mr-2': isDarkMode
              }"
              @click="clickAdd"
            >
              <font-awesome-icon :icon="['fas', 'palette']" class="mr-1" />{{ manualText }}
            </b-button>
            <b-button
              data-v-step="4"
              v-if="showPrint"
              size="sm"
              :class="{
                'box-shadow2 btn btn-success mb-2 mr-2': !isDarkMode,
                'btn btn-primary text-light mb-2 mr-2': isDarkMode
              }"
              @click="clickDownload"
            >
              <font-awesome-icon :icon="['fas', 'download']" class="mr-1" />{{ downloadText }} {{ appendedText }}
            </b-button>

            <b-button
              data-v-step="4"
              v-if="showPromo && ifAccess()"
              size="sm"
              :class="{
                'box-shadow2 btn btn-success mb-2 mr-2': !isDarkMode,
                'btn btn-primary text-light mb-2 mr-2': isDarkMode
              }"
              @click="openModal"
            >
              <font-awesome-icon :icon="['fas', 'download']" class="mr-1" />{{ downloadPromoText }}
            </b-button>

            <b-modal v-model="modalOpen" hide-footer title="Select Date Range" size="sm">
              <template>
                <div>
                  <div>
                    <h6>Start Date</h6>
                    <b-form data-v-step="2" inline class="float-right">
                      <b-input-group class="box-shadow2 ml-2 mb-2">
                        <b-input-group-append>
                          <b-form-datepicker
                            button-only
                            id="start-datepicker"
                            placeholder="Start Date"
                            :min="minDate"
                            :max="maxDate"
                            :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                            v-model="startDateValuePromo"
                          ></b-form-datepicker>
                        </b-input-group-append>
                        <b-form-input
                          id="example-input"
                          v-model="startDateValuePromo"
                          type="text"
                          placeholder="Start Date"
                          autocomplete="off"
                          :class="{
                            '': !isDarkMode,
                            'bg-dark text-light placeholder-light': isDarkMode
                          }"
                          disabled
                        ></b-form-input>
                      </b-input-group>
                      <div>
                        <h6>End Date</h6>
                        <b-input-group class="box-shadow2 ml-2 mb-2">
                          <b-input-group-append>
                            <b-form-datepicker
                              button-only
                              id="end-datepicker"
                              placeholder="End Date"
                              :min="minDate"
                              :max="maxDate"
                              :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                              v-model="endDateValue"
                            ></b-form-datepicker>
                          </b-input-group-append>
                          <b-form-input
                            id="example-input"
                            v-model="endDateValue"
                            type="text"
                            placeholder="End Date"
                            autocomplete="off"
                            :class="{
                              '': !isDarkMode,
                              'bg-dark text-light placeholder-light': isDarkMode
                            }"
                            disabled
                          ></b-form-input>
                        </b-input-group>
                        <b-button
                          :class="{
                            'box-shadow2 btn btn-success ml-3 mb-2 mt-3': !isDarkMode,
                            'btn btn-primary text-light ml-2 mb-2': isDarkMode
                          }"
                          @click="applyDatePromo"
                          >Download</b-button
                        >
                        <b-button
                          :variant="isDarkMode ? 'outline-light' : 'outline-secondary'"
                          class="box-shadow2 ml-5 mb-2 mt-3"
                          @click="clearDatePromo"
                          >Clear</b-button
                        >

                        <div class="text-right"> </div>
                      </div>
                    </b-form>
                  </div>
                </div>
              </template>
            </b-modal>

            <div v-if="downloadLoading" class="ml-2">
              <span :class="{ 'spinner spinner-black': !isDarkMode, 'spinner spinner-white': isDarkMode }"></span>
            </div>
          </b-col>
          <b-col>
            <div class="table-top-wrapper d-flex">
              <div v-if="totalCount" class="row-total-count mr-3"
                ><span>Select Count :</span> {{ selectedArticleCount }},
              </div>
              <div
                v-if="printedCount"
                :class="{ 'table-isPrinted': !isDarkMode, 'table-isPrinted-dark': isDarkMode }"
                class="row-total-count px-2 py-5 rounded mr-3"
              >
                <span>Page Print Count:</span>
                {{ printedCount }},
              </div>
              <div v-if="totalCount" class="row-total-count">
                <span>Total Count:</span>
                {{ totalCount }}
              </div>
            </div>
          </b-col>
        </b-row>
      </b-col>
    </b-row>

    <!-- total rows -->

    <!-- table content -->
    <div
      :class="{
        'box-shadow2': !isDarkMode,
        '': isDarkMode
      }"
    >
      <div
        :class="{
          'table-row table-row-header': !isDarkMode,
          'table-row-dark dark-div border-top': isDarkMode
        }"
      >
        <div
          v-for="(column, index) in columns"
          :key="column.id"
          :class="{
            ...column.class,
            'table-column': !isDarkMode,
            'table-column-dark': isDarkMode,
            'table-column-first': index === 0,
            'table-column-last-odd': columns.length === index + 1 && (columns.length - 1) % 2 === 1
          }"
          :style="columnStyle(column)"
        >
          {{ column.headerText }}
        </div>
      </div>
      <div
        :class="{
          'table-row ': !isDarkMode,
          'table-row-dark': isDarkMode
        }"
        v-for="row in filteredRows"
        :key="row.id"
      >
        <div
          v-for="(column, index) in columns"
          :key="column.id"
          :class="[
            {
              ...column.class,
              'table-column ': !isDarkMode,
              'table-column-dark': isDarkMode,
              'table-column-first': index === 0,
              'table-column-last-odd': columns.length === index + 1 && (columns.length - 1) % 2 === 1,
              'table-isPrinted': row.isPrinted === true && !isDarkMode,
              'table-isPrinted-dark': row.isPrinted === true && isDarkMode
            }
          ]"
          :style="columnStyle(column)"
        >
          <slot v-if="column.slotKey" :name="column.slotKey" v-bind:row="row"></slot>
          <div v-if="column.htmlKey" v-html="row[column.htmlKey]"></div>
          <div v-if="column.urlKey"
            ><a :href="row[column.urlKey]" target="_blank">{{ row[column.urlKey] }}</a></div
          >

          <div v-if="column.textKey === 'select'">
            <input
              class="checkbox2"
              type="checkbox"
              :disabled="isExpired(row)"
              :checked="selectedArticles.includes(row)"
              @click="select(row)"
            />
          </div>
          <span v-if="column.textKey && column.textKey != 'activeTillTime'" class="span-text">{{
            row[column.textKey]
          }}</span>
          <span v-if="column.textKey === 'activeTillTime'" class="span-text">{{ showTime(row[column.textKey]) }}</span>
          <div v-if="column.type === 'functions'" class="text-center">
            <b-button-group>
              <b-button
                data-v-step="5"
                v-if="column.functions.edit"
                size="sm"
                :disabled="isExpired(row)"
                @click="printSingleArticle(row, 'A4')"
                :variant="isDarkMode ? 'outline-light' : 'outline-secondary'"
                class="box-shadow2"
              >
                <font-awesome-icon :icon="['fas', 'clone']" class="mr-1" />Print A4 </b-button
              ><br />
              <b-button
                data-v-step="5"
                v-if="column.functions.edit"
                size="sm"
                :disabled="isExpired(row)"
                @click="printSingleArticle(row, 'A7')"
                :variant="isDarkMode ? 'outline-light' : 'outline-secondary'"
                class="box-shadow2"
              >
                <font-awesome-icon :icon="['fas', 'copy']" class="mr-1" />Print A7
              </b-button>
            </b-button-group>
          </div>
        </div>
      </div>
      <div
        v-if="!loading && rows.length === 0"
        :class="{ 'table-row table-row-empty': !isDarkMode, 'table-row-dark table-row-empty': isDarkMode }"
      >
        <div
          :class="{
            'table-column table-column-full text-center': !isDarkMode,
            'table-column-dark table-column-full text-center': isDarkMode
          }"
          >{{ emptyText }}</div
        >
      </div>
      <b-overlay v-if="loading" show :variant="isDarkMode ? 'outline-light' : 'outline-secondary'">
        <div :class="{ 'table-row table-row-empty': !isDarkMode, 'table-row-dark table-row-empty': isDarkMode }">
          <div
            :class="{
              'table-column table-column-full text-center': !isDarkMode,
              'table-column-dark table-column-full text-center': isDarkMode
            }"
          >
          </div>
        </div>
      </b-overlay>
    </div>
    <b-row class="table-bottom-wrapper mt-2 mx-0">
      <b-col lg="8" sm="12" class="px-0 d-flex align-items-center">
        <div class="mt-2">
          <input
            :checked="allSelected"
            :disabled="isDisabled"
            @click="selectAll"
            class="allimage"
            type="checkbox"
            id="scales"
          />
          <label for="scales" class="px-2">Select all </label>
        </div>
      </b-col>
      <b-col lg="4" sm="12" v-if="showPagination">
        <b-pagination-nav
          v-if="rows.length"
          v-model="currentPage"
          :link-gen="linkGen"
          :number-of-pages="totalNumberOfPage"
          use-router
          no-page-detect
          align="right"
          :class="{ '': !isDarkMode, 'dark-nav': isDarkMode }"
        ></b-pagination-nav>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import moment from 'moment';
import { mapState, mapActions } from 'vuex';
import PromoTemplateA4 from '@/components/PromoTemplateA4.vue';
import PromoTemplateA7 from '@/components/PromoTemplateA7.vue';
import PromoTemplateA4Msr from '@/components/PromoTemplateA4MSR.vue';
import PromoTemplateA7Msr from '@/components/PromoTemplateA7MSR.vue';
import PrintTemplate from '@/helper/printTemplateHelper';
import PrintHelperMSR from '@/helper/printHelperForMSR';
import Vue from 'vue';
import router from '@/router';
import Multiselect from 'vue-multiselect';
import { LoggedInUser } from '../helper/dashboard.js';

export default {
  name: 'PopBox',
  components: { PromoTemplateA4, PromoTemplateA7, PromoTemplateA4Msr, PromoTemplateA7Msr, Multiselect },
  props: {
    columns: Array,
    rows: Array,
    pagination: Object,
    baseUrl: String,
    showToolbar: Boolean,
    downloadText: String,
    downloadPromoText: String,
    searchItems: Array,
    showPrint: Boolean,
    showPromo: Boolean,
    emptyText: String,
    filterOptions: Array,
    filterOptionsForSoh: Array,
    filterOptionsForType: Array,
    filterOptionsForFamily: Array,
    printTextA4: String,
    printTextA7: String,
    loading: Boolean,
    downloadLoading: Boolean,
    manualText: String,
    showPagination: Boolean,
    modalTitle: String,
    modalContent: String,
    modalOkButton: String,
    modalCancelButton: String,
    mainFilterOptions: Array
  },
  data() {
    return {
      appendedText: 'List',
      modalVisible: false,
      currentPrintType: null,
      secondaryFilterOptions: [{ text: 'select', value: 'select' }],
      mainSelectedFilter: 'select',
      secondarySelectedFilter: 'select',
      inputSets: [],
      filterSelected: null,
      filterSelectedForSoh: null,
      filterSelectedForType: null,
      filterSelectedForFamily: null,
      startDateValue: moment().format('YYYY-MM-DD'),
      startDateValuePromo: moment().format('YYYY-MM-DD'),
      endDateValue: moment().format('YYYY-MM-DD'),
      searchTerm: null,
      minDate: moment('2020-01-01').format('YYYY-MM-DD'),
      maxDate: moment().format('YYYY-MM-DD'),
      selectedSearchVariable: this.searchItems && this.searchItems[0],
      selectedArticles: [],
      allSelected: false,
      templateDataA7: [],
      templateDataA4: [],
      templateDataA4MSR: [],
      templateDataA7MSR: [],
      isDisabled: false,
      selectedArticleCount: 0,
      field1: '',
      field2: '',
      field3: '',
      arrayOfInputFieldValues: [],
      modalOpen: false,
      showOnlyMyrd: false
    };
  },
  created() {
    if (
      this.user.roles.some(
        role => role.name === 'ADMIN' || role.name === 'SUB_ADMIN' || role.name === 'CEO' || role.name === 'HO_VIEWER'
      )
    ) {
      this.mainSelectedFilter = 'india';
    } else {
      this.mainSelectedFilter = 'select';
    }
  },
  computed: {
    ...mapState('popPrint', ['popReport', 'reportLoading']),
    ...mapState('darkMode', ['isDarkMode']),
    ...mapState('auth', ['user']),
    ...mapState('cstSubmission', ['store']),
    ...mapState('store', ['storeList', 'regionList']),
    ...mapState('asmList', ['asmList']),
    isAdmin() {
      return this.user.roles.some(role => role.name === 'ADMIN');
    },
    isSubAdmin() {
      return this.user.roles.some(role => role.name === 'SUB_ADMIN');
    },
    isCEO() {
      return this.user.roles.some(role => role.name === 'CEO' || role.name === 'HO_VIEWER');
    },
    isRSM() {
      return this.user.roles.some(role => role.name === 'REGIONAL_SALES_MANAGER');
    },
    isASM() {
      return this.user.roles.some(role => role.name === 'AREA_SALES_MANAGER');
    },
    isSSM() {
      return this.user.roles.some(role => role.name === 'STORE_SALES_MANAGER');
    },
    filteredRows() {
      const list = this.rows || [];
      if (this.showOnlyMyrd) {
        return list.filter(item => item.isMyrdPopIncluded);
      }
      // Default: show only articles that have MSR false (non-MSR)
      return list;
    },
    computDefault() {
      if (this.isAdmin()) {
        return 'India';
      } else if (this.RSM()) {
        return 'ASM';
      }
    },
    renderedASMList() {
      return this.asmList
        .map(item => ({ text: item.value, value: item.key }))
        .sort((a, b) => a.text.localeCompare(b.text));
    },
    totalStoreList() {
      return this.storeList
        .map(item => ({ text: `${item.storeName}-${item.storeid}`, value: item.storeid }))
        .sort((a, b) => a.text.localeCompare(b.text));
    },
    totalCount() {
      if (this.pagination) {
        return this.pagination.total_rows;
      }
      return 0;
    },
    printedCount() {
      if (this.rows.length > 0) {
        return this.rows.filter(item => item.isPrinted === true).length;
      }
      return 0;
    },
    totalNumberOfPage() {
      if (this.pagination) {
        if (this.pagination.total_rows && this.pagination.page_size) {
          return Math.ceil(this.pagination.total_rows / this.pagination.page_size);
        }
      }
      return 0;
    },
    currentPage() {
      if (this.pagination.page) {
        return this.pagination.page;
      }
      return 1;
    },
    updateTime() {
      if (this.rows) {
        return this.rows[0]?.updatedAt;
      }
      return -1;
    },
    newPromoLength() {
      if (this.popReport) {
        return this.popReport?.newPromoCount;
      }
      return -1;
    },
    noOfStores() {
      if (this.popReport) {
        return this.popReport?.noOfStores;
      }
      return 1;
    },
    deactivatedPromo() {
      if (this.popReport) {
        return this.popReport?.deactiveCount;
      }
      return -1;
    },
    expiredPromo() {
      if (this.popReport) {
        return this.popReport?.expiredCount;
      }
      return -1;
    },
    allPrintedCount() {
      if (this.popReport) {
        return this.popReport?.isPrintedNewPromo;
      }
      return -1;
    },
    stockAvailable() {
      if (this.popReport) {
        return this.popReport?.stockAvailable;
      }
      return -1;
    },
    mysrPromo() {
      if (this.popReport) {
        return this.popReport?.mysrPromo;
      }
      return -1;
    },
    mysrPrintedPromo() {
      if (this.popReport) {
        return this.popReport?.mysrPrintedPromo;
      }
      return -1;
    }
  },
  watch: {
    selectedArticles(newValue) {
      this.selectedArticleCount = newValue.length;
    },
    secondarySelectedFilter(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.selectedArticles = [];
        this.allSelected = false;
        if (newValue !== null) {
          this.appendedText = newValue;
        } else {
          this.appendedText = 'List';
        }
      }
      if (newValue !== oldValue && this.$route.query.filter !== newValue) {
        const query = { ...this.$route.query };
        delete query.region;
        delete query.asmName;
        delete query.store;

        if (newValue) {
          if (this.mainSelectedFilter === 'region') {
            query.region = newValue;
          } else if (this.mainSelectedFilter === 'asm') {
            query.asmName = newValue;
          } else if (this.mainSelectedFilter === 'store') {
            query.store = newValue;
          }
        }
        this.$router.push({ query }).catch(() => {});
      }
    },
    mainSelectedFilter(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.selectedArticles = [];
        this.allSelected = false;
        if (newValue !== null) {
          this.appendedText = newValue;
        } else {
          this.appendedText = 'List';
        }
      }
      if (newValue) {
        if (newValue === 'region') {
          this.secondaryFilterOptions = [...this.regionList.sort((a, b) => a.text.localeCompare(b.text))];
          //          this.secondarySelectedFilter = this.regionList[0].value;
        } else if (newValue === 'store') {
          if (this.isAdmin) {
            this.secondaryFilterOptions = [...this.totalStoreList];
            //            this.secondarySelectedFilter = this.totalStoreList[0].value;
          } else {
            this.secondaryFilterOptions = [...this.loginnedUserStores];
            //            this.secondarySelectedFilter = this.loginnedUserStores[0].value;
          }
        } else if (newValue === 'asm') {
          this.secondaryFilterOptions = this.renderedASMList.map(i => ({ text: i.text, value: i.text }));
          //          this.secondarySelectedFilter = this.renderedASMList[0].text;
        } else if (newValue === 'india') {
          this.secondarySelectedFilter = 'india';
          this.secondaryFilterOptions = [{ text: 'india', value: 'india' }];
        } else {
          this.secondarySelectedFilter = 'select';
          this.secondaryFilterOptions = [{ text: 'select', value: 'select' }];
        }
      }
    },
    filterSelected(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.selectedArticles = [];
        this.allSelected = false;
        if (newValue !== null) {
          this.appendedText = newValue;
        } else {
          this.appendedText = 'List';
        }
      }
      if (newValue !== oldValue && this.$route.query.filter !== newValue) {
        if (!newValue) {
          const query = { ...this.$route.query };
          delete query.filter;
          this.$router.push({ query }).catch(() => {});
        } else {
          this.$router.push({ query: { ...this.$route.query, filter: newValue } }).catch(() => {});
        }
      }
      if (newValue === 'DEACTIVATED PROMO' || newValue === 'EXPIRED PROMO') {
        this.isDisabled = true;
      } else {
        this.isDisabled = false;
      }
    },
    filterSelectedForSoh(newValue, oldValue) {
      if (newValue !== oldValue && this.$route.query.filter4 !== newValue) {
        if (!newValue) {
          const query = { ...this.$route.query };
          delete query.filter4;
          this.$router.push({ query }).catch(() => {});
        } else {
          this.$router.push({ query: { ...this.$route.query, filter4: newValue } }).catch(() => {});
        }
      }
    },

    filterSelectedForType(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.selectedArticles = [];
        this.allSelected = false;
      }
      if (newValue === 'MYRD') {
        this.showOnlyMyrd = true;
      } else {
        this.showOnlyMyrd = false;
      }
      if (newValue !== oldValue && this.$route.query.filter2 !== newValue) {
        if (!newValue) {
          const query = { ...this.$route.query };
          delete query.filter2;
          this.$router.push({ query }).catch(() => {});
        } else {
          this.$router.push({ query: { ...this.$route.query, filter2: newValue } }).catch(() => {});
        }
      }
    },
    filterSelectedForFamily(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.selectedArticles = [];
        this.allSelected = false;
      }
      if (newValue !== oldValue && this.$route.query.filter3 !== newValue) {
        if (!newValue) {
          const query = { ...this.$route.query };
          delete query.filter3;
          this.$router.push({ query }).catch(() => {});
        } else {
          this.$router.push({ query: { ...this.$route.query, filter3: newValue } }).catch(() => {});
        }
      }
    },
    searchTerm(newValue) {
      if (newValue === '' && Object.prototype.hasOwnProperty.call(this.$route.query, 'search')) {
        const query = { ...this.$route.query };
        delete query.search;
        this.$router.push({ query }).catch(() => {});
      }
    }
  },
  mounted() {
    if (Object.prototype.hasOwnProperty.call(this.$route.query, 'filter')) {
      this.filterSelected = this.$route.query.filter;
    } else {
      this.filterSelected = null;
    }
    if (Object.prototype.hasOwnProperty.call(this.$route.query, 'filter4')) {
      this.filterSelectedForSoh = this.$route.query.filter4;
    } else {
      this.filterSelectedForSoh = null;
    }
    if (Object.prototype.hasOwnProperty.call(this.$route.query, 'filter2')) {
      this.filterSelectedForType = this.$route.query.filter2;
      if (this.filterSelectedForType === 'MYRD') {
        this.showOnlyMyrd = true;
      }
    } else {
      this.filterSelectedForType = null;
    }
    if (Object.prototype.hasOwnProperty.call(this.$route.query, 'filter3')) {
      this.filterSelectedForFamily = this.$route.query.filter3;
    } else {
      this.filterSelectedForFamily = null;
    }
    if (Object.prototype.hasOwnProperty.call(this.$route.query, 'searchkey')) {
      this.selectedSearchVariable = this.$route.query.searchkey;
    }
    if (Object.prototype.hasOwnProperty.call(this.$route.query, 'search')) {
      this.searchTerm = this.$route.query.search;
    }
    if (Object.prototype.hasOwnProperty.call(this.$route.query, 'startdate')) {
      this.startDateValue = this.$route.query.startdate;
    }
    if (Object.prototype.hasOwnProperty.call(this.$route.query, 'startDate')) {
      this.startDateValuePromo = this.$route.query.startDate;
    }
    if (Object.prototype.hasOwnProperty.call(this.$route.query, 'endDate')) {
      this.endDateValue = this.$route.query.endDate;
    }
  },
  methods: {
    ...mapActions('popPrint', ['patchOne']),
    ifAccess() {
      const isAdmin = this.user.roles.filter(role => role.name === 'ADMIN' || role.name === 'SUB_ADMIN');
      if (isAdmin.length) {
        return true;
      }
      return false;
    },
    clickAdd() {
      this.$emit('add', {});
    },
    isExpired(row) {
      if (row.delta === 'DEACTIVATED PROMO' || row.delta === 'EXPIRED PROMO') {
        return true;
      }
      if (row && row.validTo) {
        const validToDate = moment(row.validTo, 'YYYY-MM-DD', true);
        if (validToDate.isValid() && validToDate.isBefore(moment(), 'day')) {
          return true;
        }
      }
      return false;
    },
    clickDownload() {
      this.$emit('download', {});
    },
    clickDownloadPromo() {
      this.$emit('download-promo', {});
    },

    applyDatePromo() {
      const promoDate = {
        startdate: moment(this.startDateValuePromo).format('YYYY-MM-DD'),
        enddate: moment(this.endDateValue).format('YYYY-MM-DD')
      };
      this.$emit('download-promo', { ...promoDate });
      this.modalOpen = false;
    },
    clearDatePromo() {
      if (Object.prototype.hasOwnProperty.call(this.$route.query, 'startDate')) {
        const query = { ...this.$route.query };
        delete query.startDate;
        delete query.endDate;
        this.$router.push({ query }).catch(() => {});
      }
      this.startDateValuePromo = null;
      this.endDateValue = null;
    },
    selectAll() {
      if (this.allSelected) {
        this.selectedArticles = [];
        this.allSelected = false;
      } else {
        this.selectedArticles = this.filteredRows.filter(row => row.delta === 'NEW PROMO');
        this.allSelected = true;
      }
    },
    select(row) {
      this.allSelected = false;
      if (this.selectedArticles.includes(row)) {
        this.selectedArticles = this.selectedArticles.filter(i => i !== row);
      } else {
        this.selectedArticles = [...this.selectedArticles, row];
      }
    },
    linkGen(pageNum) {
      return { path: this.baseUrl, query: { ...this.$route.query, page: pageNum } };
    },
    removeArticle(index) {
      this.inputSets.splice(index, 1);
    },
    clickModalPrint() {
      this.modalVisible = false;

      const inputs = document.getElementsByClassName('inputValues');
      this.arrayOfInputFieldValues = [];

      for (let i = 0; i < inputs.length; i++) {
        this.arrayOfInputFieldValues.push(Number(inputs[i].value) > 0 ? Number(inputs[i].value) : 1);
      }

      const arrOfArticlesToPrint = this.selectedArticles
        .map((item, index) => {
          return Array(this.arrayOfInputFieldValues[index]).fill(item);
        })
        .flat();

      // Partition by isMyrdPopIncluded: non-member (A4/A7) vs member (A4MSR/A7MSR)
      const nonMsrArticles = arrOfArticlesToPrint.filter(item => !item.isMyrdPopIncluded);
      const msrArticles = arrOfArticlesToPrint
        .filter(item => item.isMyrdPopIncluded)
        .map(item => PrintHelperMSR.enrichMsrArticleForPrint(item));

      if (this.currentPrintType === 'A7') {
        this.templateDataA7 = PrintTemplate.divideArrInSubArr(nonMsrArticles);
        this.templateDataA7MSR = PrintHelperMSR.divideArrInSubArr(msrArticles);
      } else {
        this.templateDataA4 = nonMsrArticles;
        this.templateDataA4MSR = msrArticles;
      }

      this.printCommand(this.currentPrintType);
      this.printedCommand();
    },
    async printAll(printType) {
      if (this.selectedArticles.length === 0) return;

      this.currentPrintType = printType; // store type
      this.inputSets = this.selectedArticles;
      this.modalVisible = true; // 👈 always open modal
    },
    openModal() {
      this.modalOpen = true;
    },
    printSingleArticle(row, type) {
      this.selectedArticles = [];
      this.select(row);
      this.printAll(type);
    },
    printCommand(printType) {
      this.$nextTick(() => {
        const isA7 = printType === 'A7';
        const hasNonMsr = isA7 ? this.templateDataA7.length > 0 : this.templateDataA4.length > 0;
        const hasMsr = isA7 ? this.templateDataA7MSR.length > 0 : this.templateDataA4MSR.length > 0;

        const baseUrl = window.location.origin + (process.env.BASE_URL || '/').replace(/\/?$/, '/');
        const absoluteImgUrl = path => (path.startsWith('http') ? path : baseUrl + path.replace(/^\//, ''));

        const doPrint = (type, stylesHtml, contentHtml, hasImages = false) => {
          const html = contentHtml.replace(/src="(\/img\/[^"]+)"/g, (_, path) => `src="${absoluteImgUrl(path)}"`);
          const WinPrint = window.open('', '', 'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0');
          WinPrint.document.write(`<!DOCTYPE html>
        <html>
          <head>
            ${stylesHtml}
          </head>
          <body>
            ${html}
          </body>
        </html>`);
          WinPrint.document.close();
          WinPrint.focus();
          const runPrint = () => {
            WinPrint.print();
            WinPrint.close();
          };
          if (hasImages) {
            const tryPrint = () => {
              const imgs = WinPrint.document.getElementsByTagName('img');
              if (imgs.length === 0) {
                runPrint();
                return;
              }
              let loaded = 0;
              const onDone = () => {
                loaded++;
                if (loaded >= imgs.length) {
                  clearTimeout(fallback);
                  runPrint();
                }
              };
              for (let i = 0; i < imgs.length; i++) {
                if (imgs[i].complete) onDone();
                else imgs[i].onload = onDone;
              }
            };
            const fallback = setTimeout(runPrint, 3000);
            setTimeout(tryPrint, 50);
          } else {
            runPrint();
          }
        };

        if (hasNonMsr) {
          const stylesHtml = isA7 ? PrintTemplate.getTemplatePrintCss('A7') : PrintTemplate.getTemplatePrintCss('A4');
          const contentHtml = isA7
            ? this.$refs.promoTemplateA7 && this.$refs.promoTemplateA7.$el
              ? this.$refs.promoTemplateA7.$el.innerHTML
              : ''
            : this.$refs.promoTemplateA4 && this.$refs.promoTemplateA4.$el
              ? this.$refs.promoTemplateA4.$el.innerHTML
              : '';
          doPrint(printType, stylesHtml, contentHtml, false);
        }

        if (hasMsr) {
          const runMsrPrint = () => {
            const stylesHtmlMsr = isA7
              ? PrintHelperMSR.getTemplatePrintCss('A7MSR')
              : PrintHelperMSR.getTemplatePrintCss('A4MSR');
            const contentHtmlMsr = isA7
              ? this.$refs.promoTemplateA7Msr && this.$refs.promoTemplateA7Msr.$el
                ? this.$refs.promoTemplateA7Msr.$el.innerHTML
                : ''
              : this.$refs.promoTemplateA4Msr && this.$refs.promoTemplateA4Msr.$el
                ? this.$refs.promoTemplateA4Msr.$el.innerHTML
                : '';
            doPrint(isA7 ? 'A7MSR' : 'A4MSR', stylesHtmlMsr, contentHtmlMsr, true);
          };
          if (hasNonMsr) {
            setTimeout(runMsrPrint, 1500);
          } else {
            runMsrPrint();
          }
        }
      });
    },
    printedCommand() {
      Vue.swal({
        title: 'Mark these items printed',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Marked Printed',
        background: this.isDarkMode ? '#464d54' : '#ffffff',
        customClass: {
          title: this.isDarkMode ? 'text-light' : 'text-dark',
          content: this.isDarkMode ? 'text-light' : 'text-dark'
        }
      }).then(result => {
        if (result.isDismissed) {
          return null;
        }
        if (result.value) {
          const list = {
            ids: this.selectedArticles.map(item => item.id || item._id)
          };

          this.patchOne({
            list,
            router,
            redirectUrl: '/pop'
          });
        }
      });
    },
    applyDate() {
      if (this.startDateValue) {
        this.$router
          .push({
            query: {
              ...this.$route.query,
              startdate: moment(this.startDateValue).format('YYYY-MM-DD'),
              enddate: moment(this.startDateValue).format('YYYY-MM-DD')
            }
          })
          .catch(() => {});
      }
    },
    search(event) {
      if (event.key === 'Enter') {
        if (this.searchTerm) {
          if (this.$route.query.searchTerm !== this.searchTerm) {
            if (this.selectedSearchVariable) {
              this.$router
                .push({
                  query: { search: this.searchTerm, searchkey: this.selectedSearchVariable }
                })
                .catch(() => {});
              this.applyDate();
            } else {
              this.$router.push({ query: { search: this.searchTerm } }).catch(() => {});
            }
          }
        } else {
          const query = { ...this.$route.query };
          delete query.filter;
          this.$router.push({ query }).catch(() => {});
        }
      }
    },

    clearDate() {
      if (Object.prototype.hasOwnProperty.call(this.$route.query, 'startdate')) {
        const query = { ...this.$route.query };
        delete query.startdate;
        delete query.enddate;
        this.$router.push({ query }).catch(() => {});
      }
      this.startDateValue = null;
      this.endDateValue = null;
    },
    columnStyle(column) {
      return { width: column.width };
    }
  }
};
</script>
<style src="vue-search-select/dist/VueSearchSelect.css"></style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
@media all and (max-width: 425px) {
  .columnsReverse {
    flex-direction: column-reverse;
  }
}
</style>
